import React from "react";
import PropTypes from "prop-types";
import { Grid01, Tabs } from "@opendate-app/setlist";
import { countOrUndefined } from "../../shared/components/CountBadge";

const FamilySidebar = ({ families, selected, counts, onSelect }) => (
  <nav style={{ flex: "1 1 240px" }}>
    <Tabs
      orientation="vertical"
      variant="button-brand"
      collapseBelow={0}
      aria-label="Segment families"
      value={selected}
      onChange={onSelect}
      items={[
        { value: "all", label: "All segments", icon: Grid01, count: countOrUndefined(counts.all) },
        ...families.map((family) => ({
          value: family.key,
          label: family.label,
          icon: family.icon,
          count: countOrUndefined(counts[family.key]),
        })),
      ]}
    />
  </nav>
);

FamilySidebar.propTypes = {
  families: PropTypes.arrayOf(
    PropTypes.shape({ key: PropTypes.string, label: PropTypes.string, icon: PropTypes.elementType })
  ).isRequired,
  selected: PropTypes.string.isRequired,
  counts: PropTypes.objectOf(PropTypes.number).isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default FamilySidebar;
